import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * True when the Program detail page should be read-only because the program is
 * archived. Gated by the `archivePrograms` LaunchDarkly flag so the behaviour
 * only applies where archiving is enabled. Mirrors the project-side
 * `useGetProjectReadOnly` convention.
 */
const useGetProgramReadOnly = (isArchived?: boolean): boolean => {
  const { archivePrograms = false } = useFlags();
  return Boolean(archivePrograms && isArchived);
};

export default useGetProgramReadOnly;
